jQuery(document).ready(commonInit);

function commonInit() {
	
	//don't load anything on init after this in admin editor
	if(jQuery('#wpwrap').length !== 0) return false;
	
	setupMobileMenu();
	setupColumns();
	setupBanner();
	setupHero();
	setupHeroTicker();
	setupSearch();
	
}

function setupMobileMenu() {
	
	jQuery("#mobile-nav").mmenu({
		"slidingSubmenus": false,
		"offCanvas": {
			"position": "bottom"
		},
		"navbar":{
			"add": false
		}
	}, {
	
		classNames: {
			selected: "current-menu-item",
			fixedElements: {
				
				fixed: "mobile-sticky"
				
			}
		}
	});
	
}

function setupColumns() {
	
	jQuery('.wp-block-columns').each(function(){
		
		var current = jQuery(this);
		var columnCount = jQuery('> *', current).length;
		
		current.addClass('has-'+columnCount+'-columns');
		
	});
	
}

function setupBanner() {
	
	var banner = document.getElementById('global-alert');
	var closeButton = document.getElementById('close-alert');
	var html = document.getElementsByTagName('html')[0];
	
	if (!banner || !html) {
		return false;
	}
	
	var bannerHasBeenClosed = sessionStorage.getItem('bannerHasBeenClosed');
	
	if (!bannerHasBeenClosed) {
		html.classList.add('enable-global-alert');
	}
	
	if (closeButton) {
		closeButton.addEventListener('click', function() {
			html.classList.remove('enable-global-alert');
			sessionStorage.setItem('bannerHasBeenClosed', true);
		});
	}
	
}

//usage: var first = getUrlVars()['id'];
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}
window.getUrlVars = getUrlVars;

function setCookie(cname, cvalue, exdays){
	 
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    
}
window.setCookie = setCookie;

function getCookie(cname) {
	
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    
    for(var i = 0; i <ca.length; i++){
        var c = ca[i];
        while (c.charAt(0) == ' '){
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
     
    return ""; 
    
}
window.getCookie = getCookie;


function setupHero() {

	if(jQuery('#hero-carousel:not(.slick-initialized)').length) {

		jQuery('#hero-carousel:not(.slick-initialized)').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			rows: 1,
			slidesPerRow: 1,
			dots: false,
			arrows: false,
			autoplay: true,
			autoplaySpeed: 10000,
			fade: true,
			easing: "linear",
			pauseOnHover: false,
			infinite: true,
			draggable: false,
			swipe: true,
			adaptiveHeight: false
		});
	
	}

}

function setupHeroTicker() {
	if(jQuery('.hero-images-wrapper').length) {
		// Clone images for infinite scroll effect
		const wrapper = jQuery('.hero-images-wrapper');
		const images = wrapper.html();
		wrapper.append(images); // Duplicate images

		// Calculate total width for animation
		const imageWidth = wrapper.find('img').first().outerWidth(true); // Width including margins
		const totalImages = wrapper.find('img').length;
		const duration = totalImages * 5; // 5 seconds per image

		// Add CSS animation
		wrapper.css({
			'animation': `tickerScroll ${duration}s linear infinite`,
			'width': 'max-content', // Allow wrapper to be as wide as needed
			'display': 'flex'
		});
	}
}

function setupSearch() {
	
	jQuery('.search-button').on('click', function(e){
		
		var html = jQuery('html');
		var searchButton = jQuery(this);
		var isHeader = searchButton.parents('header').length;
		
		if(!html.hasClass('search-open')) {
		
			e.preventDefault();
			
			if(isHeader) {
				html.addClass('search-open-header search-open');
				setTimeout(() => jQuery('#search-input').focus(), 100);
			} else {
				html.addClass('search-open-footer search-open');
				setTimeout(() => jQuery('#search-input').focus(), 100);
			}
			
		}
		
	}); 
	
	jQuery('.search-container form').on('click', function(e){
				
		e.stopPropagation();
		
	});
	
	jQuery('html').on('click', function(e){
		jQuery('html').removeClass('search-open-header search-open-footer search-open');
	});
	
}


// Add keyframe animation to head
const style = document.createElement('style');
style.textContent = `
@keyframes tickerScroll {
	0% { transform: translateX(0); }
	100% { transform: translateX(-50%); }
}`;
document.head.appendChild(style);



